<template>

        <v-card elevation="1" width="100%">
            <v-card-text v-if="reservation">
                <v-row no-gutters v-if="showDetails">
                  <v-col cols="4"><div><b>ID:</b></div></v-col>
                  <v-col cols="8"><div>{{ reservation.uniqueId }}</div></v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="4"><div><b>Name:</b></div></v-col>
                  <v-col cols="8"><div>{{ reservation.name }}</div></v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="4"><div><b>Space:</b></div></v-col>
                  <v-col cols="8"><div>{{ reservation.mitId }}</div></v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="4"><div><b>Start Time:</b></div></v-col>
                  <v-col cols="8"><div>{{ reservation.startDateTimeDisplay2 }}</div></v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="4"><div><b>End Time:</b></div></v-col>
                  <v-col cols="8"><div>{{ reservation.endDateTimeDisplay2 }}</div></v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="4"><div><b>Owner:</b></div></v-col>
                  <v-col cols="8"><div>{{ reservation.owner }}</div></v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="4"><div><b>Additional Owners:</b></div></v-col>
                  <v-col cols="8">
                    <div v-if="reservation.secondaryOwners">{{ reservation.secondaryOwners.toString() }}</div>
                    <div v-else>(none)</div>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="4"><div><b>Setup Requested:</b></div></v-col>
                  <v-col cols="8"><div>{{ reservation.setupStateDisplay.name }}</div></v-col>
                </v-row>
                <v-row no-gutters v-if="reservation.setupState">
                  <v-col cols="4"><div><b>Setup Description:</b></div></v-col>
                  <v-col cols="8"><div>{{ reservation.setupDescription }}</div></v-col>
                </v-row>
                <div v-if="reservation.recurring">
                  <v-row no-gutters>
                    <v-col cols="4"><div><b>Repeats:</b></div></v-col>
                    <v-col cols="8"><div>{{ reservation.recurring.repeatChoice }}</div></v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="4"></v-col>
                    <v-col cols="8" v-if="reservation.recurring.repeatChoice === 'weekly'">
                      <span>Occurs every 
                          <span v-for="(item, name) in reservation.recurring.days" :key="name" style="text-transform: capitalize;">
                              <span v-if="item">{{name.substring(0,3)+', '}}</span>
                          </span>
                        until 
                        <span>{{reservation.recurring.repeatsUntilDate.format('ddd MMM DD YYYY')}}</span>
                      </span>
                    </v-col>
                    <v-col cols="8" v-if="reservation.recurring.repeatChoice === 'monthly'">
                      <span>Occurs every day {{ reservation.startDateTime.format('D') }} of each month until <span>{{reservation.recurring.repeatsUntilDate.format('ddd MMM DD YYYY')}}</span></span>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="4"><div><b>Ignored Conflicts:</b></div></v-col>
                    <v-col cols="8"><div v-if="reservation.recurring.conflictsIgnored.length <= 0">None.</div></v-col>
                  </v-row>
                  <v-row no-gutters v-for="(c, i) in reservation.recurring.conflictsIgnored" :key="i">
                    <v-col cols="4"><div></div></v-col>
                    <v-col cols="8">
                            <v-row no-gutters>
                              <v-col cols="2"><v-icon color="amber">mdi-calendar-alert</v-icon></v-col>
                              <v-col>
                                <div><b>{{c.startTime.format('ddd MMM DD YYYY') }}</b></div>
                                <div>{{c.startTime.format('h:mm A')}} for {{c.startTime.from(c.endTime,true)}} </div>
                              </v-col>
                            </v-row>
                            
                    </v-col>
                  </v-row>
                </div>
                <v-row no-gutters v-if="reservation.recurringUniqueId">
                  <v-col cols="12"><div style="color:red"><b>**Part of recurring series {{ reservation.recurringUniqueId }}</b></div></v-col>
                </v-row>
                
            </v-card-text>
            <v-card-text v-else>
              <div>No data to display</div>
            </v-card-text>
        </v-card>
</template>

<script>

export default {
  name: 'BaseMitReservationReadOnly',
  components: {
  },
  props: {
    reservation:{
        default () {
          return null;
        },
        type: Object
      },
    showDetails:{
      default () {
        return false;
      },
      type: Boolean
    }
  },
  data: function() {
    return {
    }
  },
  created() {
  },
  methods : {
  }
}
</script>

<style lang="scss" scoped>
</style>
